import React from 'react';
import MasterLayout from "../masterLayout/MasterLayout";
import DashBoardLayerNine from "../components/DashBoardLayerNine";
import HomeBreadcrumb from "../components/HomeBreadcrumb";
import { DateProvider } from "../contexts/DateContext"; 

const HomePage = () => {
  return (
    <DateProvider>
      <MasterLayout>
        <HomeBreadcrumb />
        <DashBoardLayerNine />
      </MasterLayout>
    </DateProvider>
  );
};

export default HomePage;
